import { Observable } from 'rxjs'
import { UserList } from '../models/user-list'
import { UserSearch } from '../models/user-search'
import { UserListToExcel } from '../models/user-list-excel'

export abstract class UserListGateway {
    abstract retrieveUserListData(userSearch: UserSearch): Observable<UserList[]>
    abstract getUserList(): Observable<UserList[]>
    abstract getAgentList(): Observable<UserList[]>

    abstract retrieveExcelUserListData(userSearch: UserSearch): Observable<UserListToExcel[]>
    abstract retrieveUserListDataSync(userSearch: UserSearch): UserList[]
    abstract getTrainingYears(selectedYear: number): Observable<number[]>
    // abstract quickSearchUserListData(): Observable<UserList[]>
    // abstract getUserSearchData(userSearch: UserSearch): Observable<UserSearch>
    // abstract getUserListData(userlist: UserList[]): Observable<UserList[]>
}
